import TweenMax from 'gsap'

export const duration = 0.7
export const ease = TweenMax.Expo.easeInOut
export const imgWidth = 1500
export const imgHeight = 944



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/